import React, { useRef, useState } from 'react';
import { IconCheck, IconX } from '@tabler/icons-react';
import type { SelectOption } from '../../../shared/ui/Select';
import { Button } from '../../../shared/ui/Button';
import { Select } from '../../../shared/ui/Select';

interface AddParticipantModalProps {
  groupOptions: SelectOption[];
  onClose: () => void;
  onSave: (groupId: string, actual: boolean) => Promise<void>;
}

const AddParticipantModal: React.FC<AddParticipantModalProps> = ({ groupOptions, onClose, onSave }) => {
  const [group, setGroup] = useState('');
  const [saving, setSaving] = useState(false);
  const overlayRef = useRef<HTMLDivElement>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!group) return;
    setSaving(true);
    try {
      await onSave(group, true);
      onClose();
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="mo open" ref={overlayRef} onClick={e => e.target === overlayRef.current && onClose()}>
      <div className="cm cm-create" style={{ maxWidth: 440, overflow: 'visible' }}>
        <div className="cm-top">
          <div className="cm-ti">Добавить участника</div>
          <div className="cm-sp" />
          <button className="cm-x" type="button" onClick={onClose}>
            <IconX size={16} stroke={2} />
          </button>
        </div>
        <form className="cm-create-body" onSubmit={handleSubmit} style={{ gap: 16, overflow: 'visible' }}>
          <div className="adm-field">
            <label className="adm-label">
              Группа <span className="adm-req">*</span>
            </label>
            <Select
              options={groupOptions}
              value={group}
              onChange={setGroup}
              placeholder="Выберите группу..."
              searchable
            />
          </div>
          <div className="adm-form-actions">
            <Button variant="adm-cancel" type="button" onClick={onClose}>
              Отмена
            </Button>
            <Button variant="adm-save" type="submit" disabled={!group || saving}>
              {saving ? <span className="adm-btn-spinner" /> : <IconCheck size={15} stroke={2.5} />}
              Добавить
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export { AddParticipantModal };
